
export default function formatNumberFilter(value) {
  if (!value) return value
  let num = Number(value)
  return ('' + num.toFixed(2)).replace('.', ',')
}



// WEBPACK FOOTER //
// ./src/filters/formatNumberFilter.js